(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pgc-cart-content"] && !Shopify.designMode) return;
  try {
    (() => {
 if (window.PgcCart) return;
 let busy = false, generation = 0, opener = null, scrollPosition = 0, continueTo = null;
 const roots = () => [...document.querySelectorAll('[data-pgc-cart]')];
 const dialog = () => document.querySelector('[data-pgc-drawer]');
 const config = root => JSON.parse(root.querySelector('[data-cart-config]').textContent);
 const sections = () => [...new Set(roots().map(r => config(r).section))];
 const drawerRoot = () => dialog()?.querySelector('[data-pgc-cart]');
 function message(root, text) { const target = root?.querySelector('[data-cart-error]'); if (target) target.textContent = text; }
 function show(trigger) {
  const d = dialog(); if (!d || typeof d.showModal !== 'function') return false;
  if (!d.open) {
   opener = trigger || document.activeElement; scrollPosition = window.scrollY;
   document.documentElement.classList.add('pgc-cart-open');
   document.body.style.setProperty('--pgc-scroll-offset', `-${scrollPosition}px`);
   d.showModal(); d.querySelector('[data-drawer-close]').focus({preventScroll:true});
  }
  return true;
 }
 function afterClose() {
  document.documentElement.classList.remove('pgc-cart-open');
  document.body.style.removeProperty('--pgc-scroll-offset'); window.scrollTo(0, scrollPosition);
  if (opener?.isConnected) opener.focus({preventScroll:true});
  if (continueTo) {
   const url=new URL(continueTo,window.location.href);continueTo=null;
   if(url.origin===window.location.origin && url.pathname===window.location.pathname){window.location.hash=url.hash;document.querySelector(url.hash)?.scrollIntoView({block:'start'});}
   else window.location.assign(url.href);
  }
 }
 function close() { const d = dialog(); if (d?.open) d.close(); }
 function replaceCart(html, id) {
  if (!html) return false;
  const next = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-pgc-cart]');
  const current = roots().find(r => config(r).section === id);
  if (!next || !current) return false;
  current.replaceWith(next);
  document.querySelectorAll('[data-cart-count]').forEach(el => el.textContent = next.dataset.itemCount);
  return true;
 }
 async function refresh() {
  const ids = sections(); if (!ids.length) return;
  const stamp = generation;
  const url = new URL(window.location.href); url.searchParams.set('sections', ids.join(','));
  let result;
  try {
   const response = await fetch(url.pathname + url.search, {headers:{Accept:'application/json'}});
   if (!response.ok) throw Error('Section refresh failed');
   result = await response.json();
   if (ids.some(id => !result[id])) throw Error('Missing cart section');
  } catch (_) {
   // Request fresh sections without changing line quantities, notes or discounts.
   const updateUrl = config(roots()[0]).change.replace('change.js', 'update.js');
   const response = await fetch(updateUrl, {method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({updates:{},sections:ids,sections_url:window.location.pathname})});
   if (!response.ok) throw Error(config(roots()[0]).failure);
   result = (await response.json()).sections || {};
  }
  if (stamp !== generation) return;
  for (const id of ids) if (!replaceCart(result[id], id)) throw Error(config(roots()[0]).failure);
 }
 function lock() {
  const controls = [...document.querySelectorAll('[data-pgc-cart] button,[data-pgc-cart] input,[data-pgc-form] button,[data-pgc-form] input')];
  const state = controls.map(el => el.disabled);
  controls.forEach(el => el.disabled = true);
  roots().forEach(r => r.setAttribute('aria-busy','true'));
  return () => {
   controls.forEach((el,i) => {if(el.isConnected)el.disabled=state[i];});
   roots().forEach(r => r.removeAttribute('aria-busy'));
  };
 }
 async function mutate(url, body, root, focus, adding, trigger) {
  if (busy) return; busy = true; generation++;
  const strings = config(root), ids = sections(), release = lock();
  message(root,'');
  const status = trigger?.closest('form')?.querySelector('[data-form-status]');
  if (status) status.textContent = strings.adding;
  let accepted = false;
  try {
   let previousCount = null, steps = 0;
   while (true) {
    const current = roots().find(r => config(r).section === strings.section) || drawerRoot();
    const payload = typeof body === 'function' ? body(config(current).gameLines) : body;
    if (!payload) break;
    const count = config(current).gameLines.reduce((sum,line) => sum + line.quantity, 0);
    if (typeof body === 'function' && (count === previousCount || steps >= 50)) throw Error(strings.failure);
    previousCount = count; steps++;
    const response = await fetch(url,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({...payload,sections:ids,sections_url:window.location.pathname})});
    const cart = await response.json();
    if (!response.ok) { const err = new Error(cart.description || cart.message || strings.failure); err.confirmed = true; throw err; }
    accepted = true;
    let missing = false;
    ids.forEach(id => { if (!replaceCart(cart.sections?.[id],id)) missing=true; });
    if (adding) show(trigger);
    if (missing) await refresh();
    if (typeof body !== 'function') break;
   }
   const next = roots().find(r => config(r).section === strings.section) || drawerRoot();
   if (!adding) {
    const target = [...next.querySelectorAll('[data-focus]')].find(el => el.dataset.focus === focus) || next.querySelector('[data-cart-heading]');
    target?.focus({preventScroll:true});
   }
   const live = next?.querySelector('[data-cart-status]'); if(live)live.textContent=adding?strings.added:strings.updated;
   if (status) status.textContent = strings.added;
  } catch (e) {
   // A lost response can still mean Shopify accepted the change. Never repeat an add automatically.
   const uncertain = !e.confirmed;
   if (uncertain) { try { await refresh(); } catch (_) {} }
   if (adding && (accepted || uncertain)) show(trigger);
   const text = uncertain ? strings.uncertain : e.message;
   const current = roots().find(r => config(r).section === strings.section) || root;
   message(current,text); if(status) status.textContent=text;
   roots().forEach(r => r.querySelectorAll('[data-cart-quantity]').forEach(input => input.value=input.defaultValue));
  } finally { release(); busy=false; }
 }
 function change(control, quantity) {
  const root=control.closest('[data-pgc-cart]'); if(!root || busy)return;
  if(!Number.isInteger(quantity)||quantity<0){message(root,config(root).invalid);control.value=control.defaultValue;return;}
  return mutate(config(root).change,{id:control.dataset.key,quantity},root,control.dataset.focus,false,control);
 }
 function bundle(control) {
  const root=control.closest('[data-pgc-cart]'), target=Number(control.dataset.cartBundle);
  if(!root || busy || !Number.isInteger(target) || target<1 || target>4)return;
  // Read fresh line keys after each change: applying a discount can change them.
  // Reduce trailing game lines first; preserve unrelated products and line properties.
  const nextChange=lines=>{
   const count=lines.reduce((sum,line)=>sum+line.quantity,0);
   if(count===target)return null;
   if(!lines.length)throw Error(config(root).failure);
   const line=count<target?lines[0]:lines[lines.length-1];
   return {id:line.key,quantity:Math.max(0,line.quantity+target-count)};
  };
  return mutate(config(root).change,nextChange,root,control.dataset.focus,false,control);
 }
 window.PgcCart = {
  add(form, trigger) {
   if(busy || trigger.disabled)return;
   const root=drawerRoot(); if(!root)return;
   const data=new FormData(form), quantity=Number(data.get('quantity'));
   if(!Number.isInteger(quantity)||quantity<1)return;
   return mutate(config(root).add,{items:[{id:data.get('id'),quantity}]},root,null,true,trigger);
  },
  async open(trigger) {
   if(!show(trigger))return false;
   if(!busy){try{await refresh();}catch(e){message(drawerRoot(),config(drawerRoot()).failure);}}
   return true;
  }, close
 };
 document.addEventListener('click',e=>{
  const bag=e.target.closest('[data-cart-open]');
  if(bag && !e.metaKey && !e.ctrlKey && !e.shiftKey && e.button===0 && typeof dialog()?.showModal==='function'){
   e.preventDefault();window.PgcCart.open(bag);return;
  }
  if(e.target.closest('[data-drawer-close]')){close();return;}
  const shopping=e.target.closest('[data-pgc-drawer] a[href$="#gifts"]');
  if(shopping){e.preventDefault();continueTo=shopping.href;close();return;}
  const pack=e.target.closest('[data-cart-bundle]');
  if(pack){e.preventDefault();bundle(pack);return;}
  const control=e.target.closest('[data-cart-change]');
  if(control){e.preventDefault();change(control,Number(control.dataset.quantity));}
 });
 document.addEventListener('change',e=>{if(e.target.matches('[data-cart-quantity]'))change(e.target,Number(e.target.value));});
 document.addEventListener('submit',e=>{
  if(e.target.closest('[data-pgc-cart]') && busy)e.preventDefault();
 });
 function initDialog(){
  const d=dialog();if(!d||d.dataset.ready)return;d.dataset.ready='true';
  d.addEventListener('close',afterClose);
  d.addEventListener('click',e=>{if(e.target===d){const r=d.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)close();}});
  document.querySelectorAll('[data-cart-open]').forEach(a=>{a.setAttribute('aria-haspopup','dialog');a.setAttribute('aria-controls',d.id);});
 }
 initDialog();
 document.addEventListener('shopify:section:load',initDialog);
 document.addEventListener('shopify:section:unload',e=>{if(e.target.contains(dialog()))close();});
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pgc-deck-browser"] && !Shopify.designMode) return;
  try {
    class PgcDeckBrowser extends HTMLElement {
 connectedCallback(){
  if(this.controller)return;
  this.controller=new AbortController();this.index=0;this.version=0;this.timer=0;
  this.cards=JSON.parse(this.querySelector('[data-deck-json]').textContent);
  this.cards.forEach((card,index)=>{const option=document.createElement('option');option.value=String(index);option.textContent=card.title;this.querySelector('select').append(option);});
  this.flip=this.querySelector('[data-deck-flip]');this.front=this.querySelector('[data-deck-front]');this.dialog=this.querySelector('dialog');
  const listen=(el,event,fn)=>el.addEventListener(event,fn,{signal:this.controller.signal});
  listen(this,'click',e=>{
   const button=e.target.closest('[data-deck-action]');if(!button)return;
   const action=button.dataset.deckAction;
   if(action==='flip'){this.setRevealed(this.flip.getAttribute('aria-pressed')!=='true');}
   if(action==='next')this.showCard(this.index+1);
   if(action==='previous')this.showCard(this.index-1);
   if(action==='shuffle')this.showCard(this.index+1+Math.floor(Math.random()*(this.cards.length-1)));
   if(action==='zoom'){this.setRevealed(true);this.dialog.showModal();}
   if(action==='close')this.dialog.close();
  });
  listen(this.querySelector('select'),'change',e=>this.showCard(Number(e.target.value)));
  listen(this,'keydown',e=>{
   if(/SELECT|INPUT|TEXTAREA/.test(e.target.tagName))return;
   if(e.key==='ArrowRight'){e.preventDefault();this.showCard(this.index+1);}
   if(e.key==='ArrowLeft'){e.preventDefault();this.showCard(this.index-1);}
  });
  let touch;
  listen(this.flip,'pointerdown',e=>{if(e.pointerType==='touch')touch={x:e.clientX,y:e.clientY};});
  listen(this.flip,'pointerup',e=>{if(!touch)return;const dx=e.clientX-touch.x,dy=e.clientY-touch.y;touch=null;if(Math.abs(dx)>55&&Math.abs(dx)>Math.abs(dy)*1.5){this.suppressClick=true;this.showCard(this.index+(dx<0?1:-1));}});
  listen(this.flip,'click',e=>{if(this.suppressClick){e.stopPropagation();this.suppressClick=false;}});
  listen(this.flip,'pointercancel',()=>{touch=null;});
  listen(this.dialog,'click',e=>{if(e.target===this.dialog){const r=this.dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)this.dialog.close();}});
  this.render();this.querySelector('[data-deck-controls]').hidden=false;
 }
 setRevealed(value){this.flip.setAttribute('aria-pressed',String(value));this.flip.setAttribute('aria-label',value?this.dataset.hide:this.dataset.reveal);this.querySelector('[data-deck-hint]').textContent=value?this.dataset.flipBack:this.dataset.flipHint;}
 render(){
  const card=this.cards[this.index];
  this.front.src=card.url;this.front.alt=card.title;
  this.querySelector('[data-deck-title]').textContent=card.title;
  this.querySelectorAll('[data-deck-position]').forEach(el=>el.textContent=(this.index+1)+' / '+this.cards.length);
  this.querySelector('select').value=String(this.index);
  this.querySelector('[data-deck-zoom-image]').src=card.url;
  this.querySelector('[data-deck-zoom-image]').alt=card.title;
  this.querySelector('[data-deck-zoom-title]').textContent=card.title;
  this.querySelector('[data-deck-transcript]').textContent=card.text||card.title;
 }
 showCard(next){
  if(this.busy)return;
  next=(next+this.cards.length)%this.cards.length;if(next===this.index){this.setRevealed(true);return;}
  this.busy=true;const version=++this.version;
  this.querySelectorAll('[data-deck-action=next],[data-deck-action=previous],[data-deck-action=shuffle],select').forEach(el=>el.disabled=true);
  this.setAttribute('aria-busy','true');this.querySelector('[data-deck-error]').textContent='';
  const done=()=>{this.busy=false;this.removeAttribute('aria-busy');this.classList.remove('is-changing');this.querySelectorAll('button,select').forEach(el=>el.disabled=false);};
  const image=new Image();
  const fail=()=>{if(version!==this.version||!this.isConnected)return;clearTimeout(this.timer);done();this.querySelector('[data-deck-error]').textContent=this.dataset.error;this.querySelector('select').value=String(this.index);};
  image.onerror=fail;
  image.onload=()=>{
   if(version!==this.version||!this.isConnected)return;
   clearTimeout(this.timer);
   const reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches||this.closest('.is-motion-paused')||this.dialog.open;
   this.classList.toggle('is-changing',!reduced);
   this.timer=setTimeout(()=>{if(version!==this.version||!this.isConnected)return;this.index=next;this.render();this.setRevealed(true);done();},reduced?0:230);
  };
  this.timer=setTimeout(fail,12000);image.src=this.cards[next].url;
 }
 disconnectedCallback(){this.version++;clearTimeout(this.timer);this.controller?.abort();this.controller=null;this.busy=false;}
}
if(!customElements.get('pgc-deck-browser'))customElements.define('pgc-deck-browser',PgcDeckBrowser);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pgc-pong-scene"] && !Shopify.designMode) return;
  try {
    class PgcPongScene extends HTMLElement {
 connectedCallback(){
  if(this.controller)return;this.controller=new AbortController();this.frame=0;this.replayFrame=0;this.progress=0;this.paused=false;
  this.motion=window.matchMedia('(prefers-reduced-motion: reduce)');this.root=this.closest('.pgc-v2');
  this.ball=this.querySelector('[data-pong-ball]');this.cup=this.querySelector('[data-pong-cup]');this.splash=this.querySelector('[data-pong-splash]');this.shadow=this.querySelector('[data-pong-shadow]');this.score=this.querySelector('[data-pong-score]');
  const listen=(el,event,fn,options={})=>el?.addEventListener(event,fn,{...options,signal:this.controller.signal});
  const schedule=()=>{if(this.frame||this.replayFrame||this.paused||this.motion.matches||this.root?.classList.contains('is-motion-paused'))return;this.frame=requestAnimationFrame(()=>{this.frame=0;const r=this.getBoundingClientRect();if(r.bottom<0||r.top>innerHeight)return;this.draw(Math.max(0,Math.min(1,(innerHeight*.9-r.top)/(innerHeight*.7))));});};
  listen(window,'scroll',schedule,{passive:true});listen(window,'resize',schedule,{passive:true});
  listen(this.querySelector('[data-pong-replay]'),'click',()=>{
   cancelAnimationFrame(this.replayFrame);this.replayFrame=0;this.querySelector('[data-pong-status]').textContent='';
   if(this.motion.matches||this.paused||this.root?.classList.contains('is-motion-paused')){this.draw(1);this.querySelector('[data-pong-status]').textContent=this.dataset.scored;return;}
   let start;const tick=now=>{if(!this.isConnected)return;if(start===undefined)start=now;const p=Math.min(1,(now-start)/1500);this.draw(p);if(p<1)this.replayFrame=requestAnimationFrame(tick);else{this.replayFrame=0;this.querySelector('[data-pong-status]').textContent=this.dataset.scored;}};
   this.replayFrame=requestAnimationFrame(tick);
  });
  listen(this.querySelector('[data-pong-pause]'),'click',e=>{this.paused=!this.paused;e.currentTarget.setAttribute('aria-pressed',String(this.paused));e.currentTarget.textContent=this.paused?this.dataset.resume:this.dataset.pause;if(this.paused)this.stop();else schedule();});
  listen(this.motion,'change',()=>{this.stop();if(this.motion.matches)this.draw(1);else schedule();});
  this.observer=new MutationObserver(()=>{if(this.root.classList.contains('is-motion-paused'))this.stop();else schedule();});if(this.root)this.observer.observe(this.root,{attributes:true,attributeFilter:['class']});
  listen(document,'visibilitychange',()=>{if(document.hidden)this.stop();else schedule();});
  if(this.motion.matches)this.draw(1);else{this.draw(0);schedule();}
 }
 stop(){cancelAnimationFrame(this.frame);cancelAnimationFrame(this.replayFrame);this.frame=0;this.replayFrame=0;}
 draw(p){
  this.progress=p;const q=Math.min(1,p/.7);const x=80+465*q,y=270-200*Math.sin(q*Math.PI)-20*q;
  this.ball.setAttribute('transform',`translate(${x} ${y}) scale(${1-.25*q})`);this.ball.setAttribute('opacity',String(p>.7?Math.max(0,1-(p-.7)*18):1));
  this.shadow.setAttribute('cx',String(x));this.shadow.setAttribute('rx',String(22-12*Math.sin(q*Math.PI)));
  const hit=Math.max(0,(p-.67)/.33),rise=Math.min(1,hit*2.2);const scale=rise*(1-.2*Math.max(0,(hit-.5)*2));
  this.splash.setAttribute('opacity',String(Math.min(1,hit*6)));this.splash.setAttribute('transform',`translate(545 246) scale(${scale})`);
  this.cup.setAttribute('transform',`rotate(${Math.sin(hit*Math.PI*3)*5*(1-hit)} 545 380)`);this.score.setAttribute('opacity',String(Math.min(1,hit*3)));
 }
 disconnectedCallback(){this.stop();this.controller?.abort();this.controller=null;this.observer?.disconnect();}
}
if(!customElements.get('pgc-pong-scene'))customElements.define('pgc-pong-scene',PgcPongScene);
  } catch(e) { console.error(e); }
})();

})();
